import { SmallButton } from "@sellar-io/components";
import { ReactElement, useEffect, useState } from "react";
import { Icon, SupplierOnly } from "../../../components";
import { NavigationBarMenu } from "../../../components/navigation/NavigationBar";
import { ORDER_DETAILS } from "../../../constants/routes";
import { useEvents } from "../../../hooks";
import { useAncestorRouteParams } from "../../../hooks/useRouteParams";
import { useRemoteFeatureFlags } from "../../../hooks/useRemoteFeatureFlags";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { SelectCustomerDialog } from "../modals/SelectCustomerDialog/SelectCustomerDialog";
import { TabbedListHeader } from "../../../components/navigationTabs/TabbedListHeader";
import { OrdersListMenu } from "./AllOrders/AllOrdersList";
import { BuyerAllOrdersList } from "./AllOrders/BuyerAllOrdersList";
import { BuyerOrdersListTabs } from "./BuyerOrdersListTabs";
import { SupplierOrdersListTabs } from "./SupplierOrdersListTabs";

export function Orders(): ReactElement {
  const orderParams = useAncestorRouteParams(ORDER_DETAILS);
  const selectedOrderId = orderParams ? Number(orderParams.orderId) : null;
  const { business } = useSellarCurrentBusiness();
  const { track } = useEvents();
  const [newOrderModalActive, setNewOrderModalActive] = useState(false);

  const { isActive } = useRemoteFeatureFlags();
  useEffect(() => {
    track("Orders Page Viewed");
  }, [track]);

  return (
    <>
      <div className="flex flex-col sm:min-h-full">
        <NavigationBarMenu
          title={"Orders"}
          borderBottom={false}
          rightComponent={
            <SupplierOnly>
              <SmallButton onClick={() => setNewOrderModalActive(true)}>
                <Icon icon={"PLUS"} size={0.7} /> New
              </SmallButton>
            </SupplierOnly>
          }
        />
        <div className="bg-gray-100 sm:flex-1">
          {business?.Retailer ? (
            <>
              {isActive("sellarCreditOobo") ? (
                <BuyerOrdersListTabs selectedOrderId={selectedOrderId} />
              ) : (
                <>
                  <TabbedListHeader>
                    <OrdersListMenu />
                  </TabbedListHeader>
                  <BuyerAllOrdersList selectedOrderId={selectedOrderId} />
                </>
              )}
            </>
          ) : (
            <SupplierOrdersListTabs selectedOrderId={selectedOrderId} />
          )}
        </div>
      </div>
      <SelectCustomerDialog
        active={newOrderModalActive}
        onDismiss={() => setNewOrderModalActive(false)}
      />
    </>
  );
}
